import React from 'react';
import PropTypes from 'prop-types';
import './BeneficiariesModal.scss';

const BeneficiariesModalTitle = ({ title, selectedGroup, description }) => {
  return (
    <div  className="b-grid-item--12-col">
      <div id="modal-header" className={"b-typography-serif--headline--200 b-font-weight-bold toolTipGap"}>
        {title}
      </div>
      <div className="b-typography-sans-serif--body--200">
        <span className="b-font-weight-light">Assigned to </span>
        <span className="b-font-weight-bold blocked_data">{selectedGroup}</span>
      </div>
      <div className="b-typography-serif--body--200">
        {description}
      </div>
    </div>
  );
};

BeneficiariesModalTitle.propTypes = {
  title: PropTypes.node.isRequired,
  selectedGroup: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default BeneficiariesModalTitle;